import React, { useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';

import Setup from './dashboard/Setup';
import Settings from './dashboard/Settings';
import Census from './dashboard/Census';
import Waitlist from './dashboard/Waitlist';
import Attendance from './dashboard/Attendance';
import ProDialog from '../components/common/ProDialog';

import useRolePermissionServices from '../hooks/useRolePermissionServices';
import useFormServices from '../hooks/useFormServices';

import { useAuthServices } from '../hooks/useAuthServices';
import { useDialogService } from '../hooks/useDialogService';

import _ from 'lodash'
import "./DashBoard.css"
import 'primeflex/primeflex.css';

export const Dashboard = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {actions :{GetToken}} = useAuthServices();     
    const {data:{SetupRoles}} = useRolePermissionServices(); 
    const {data:{show, header, body, icon, labelOk, labelCancel, severity}} = useDialogService();
    const {data:{isDirty}, actions:{ConfirmFormAction}} = useFormServices()
   
    useEffect(()=>{       
        GetToken && GetToken();
    }, [GetToken])
   
    const tabChange = async (e) => {
        if(isDirty)
            await ConfirmFormAction(()=>{setActiveIndex(e.index)})
        else
            setActiveIndex(e.index)        
    };

    const bedmanagementConfig = [
         {header:"Census", component:<Census/>, visibility:true}
        ,{header:"Attendance", component:<Attendance/>, visibility:true}
        ,{header:"Waitlist", component:<Waitlist/>, visibility:true} 
        ,{header:"Setup", component:<Setup/>, visibility:SetupRoles.canViewSetup}
        ,{header:"Settings", component:<Settings/>, visibility:SetupRoles.canViewSetup}
    ]

    return (
        <div className="p-grid">
             <ProDialog show={show} header={header} body={body} icon={icon} labelOk={labelOk} labelCancel={labelCancel} severity={severity}/>
            <div className="p-col-12" style={{ display: 'none' }}>
                <h4>Bed Management</h4>
            </div>

            <div className="p-col-12">               
                  <TabView activeIndex={activeIndex} onTabChange={(e) => tabChange(e)}>
                    {_.filter(bedmanagementConfig, (c)=>c.visibility).map((config, index)=>{
                        return  <TabPanel key={index} header={config.header}>
                        {config.component}
                    </TabPanel>
                    })}
                </TabView>
            </div>
        </div>
    )
}
